// constants
import { JobSubmissionsActionTypes } from './constants';

const INIT_STATE = {
    jobSubmissions: [],
    jobTitle: {},
    page: 1,
    limit: 10,
    totalPages: 0,
    totalResults: 0,
    loading: false,
    hasErrors: false,
    submitted: false,
    isDeleted: false,
};

interface JobSubmissionsActionType {
    type:
    | JobSubmissionsActionTypes.API_RESPONSE_SUCCESS
    | JobSubmissionsActionTypes.API_RESPONSE_ERROR
    | JobSubmissionsActionTypes.JOB_SUBMISSIONS_LIST

    payload: {
        actionType?: string;
        responseData?: any;
        error?: any;
        validationError?: { error: string; key: string; }[];
        hasErrors: boolean,
        submitted: boolean,
        isDeleted: boolean,
    };
}

interface State {
    jobSubmissions: any;
    jobTitle: any;
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
}

const JobSubmissions = (state: State = INIT_STATE, action: JobSubmissionsActionType): any => {
    switch (action.type) {
        case JobSubmissionsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload?.actionType) {
                case JobSubmissionsActionTypes.JOB_SUBMISSIONS_LIST: {
                    return {
                        ...state,
                        jobSubmissions: action.payload?.responseData?.data,
                        page: action.payload?.responseData?.page,
                        limit: action.payload?.responseData?.limit,
                        totalPages: action.payload?.responseData?.totalPages,
                        totalResults: action.payload?.responseData?.totalResults,
                        loading: true,
                        submitted: false,
                    };
                }

                default:
                    return { ...state };
            }

        case JobSubmissionsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload?.actionType) {
                case JobSubmissionsActionTypes.JOB_SUBMISSIONS_LIST: {
                    return {
                        ...state,
                        error: action.payload.error,
                        hasErrors: true,
                        loading: true,
                        submitted: false,
                    };
                }

                default:
                    return { ...state };
            }
        default:
            return { ...state };
    }
};

export default JobSubmissions;
